import { connect } from 'react-redux';

import { TabsState } from 'ia-react-core/~/interfaces/TabsState';
import compose from '../../../utils/components/_compose';
import get from '../../../utils/accessors/get';

import Tabs, { TabsComposedProps } from './Tabs';

export const mapStateToProps = (state: TabsState, { name, selectedTab, scope = [] }: TabsComposedProps) => {
  const isControlled = typeof selectedTab !== 'undefined';
  const path = [...scope, name, 'selectedTab'].join('.');

  return ({
    selectedTab: isControlled ? selectedTab : get(state, path),
    isControlled,
  });
};

export default compose(
  connect(mapStateToProps),
)(Tabs);
